/** Minutes as "10 days 16 hours 39 min"; under an hour just the minutes. */
export const formatMinutes = (minutes: number) => {
  const total = Math.round(minutes);
  if (total < 60) {
    return `${total} min`;
  }
  const days = Math.floor(total / 1440);
  const hours = Math.floor((total % 1440) / 60);
  const mins = total % 60;
  const parts: string[] = [];
  if (days > 0) parts.push(`${days} ${days === 1 ? "day" : "days"}`);
  if (hours > 0) parts.push(`${hours} ${hours === 1 ? "hour" : "hours"}`);
  if (mins > 0) parts.push(`${mins} min`);
  return parts.join(" ");
};
